import api from "../utils/api-axios";

/**
 * Exchange API functions
 */
export const exchangeApi = {
  // Create a new exchange request
  createExchange: async (exchangeData) => {
    return api.post("/exchanges", exchangeData);
  },

  // Confirm an exchange
  confirmExchange: async (exchangeId) => {
    return api.put(`/exchanges/${exchangeId}/confirm`);
  },

  // Get exchange by conversation and listing
  getExchange: async (conversationId, listingId) => {
    return api.get("/exchanges", {
      params: {
        conversationId,
        listingId,
      },
    });
  },

  // Get all exchanges for current user
  getUserExchanges: async (status = null, page = 1, limit = 10) => {
    const params = { page, limit };
    if (status) params.status = status;

    return api.get("/exchanges/user", { params });
  },

  getExchangeByConversation: async (conversationId) => {
    return api.get(`/exchanges/conversation/${conversationId}`);
  },

  getCurrentUsersListings: async (currentUserId) => {
    return api.get(`/listing/user/${currentUserId}`);
  },

  getOtherUserListings: async (otherUserId) => {
    return api.get(`/listing/user/${otherUserId}`);
  },

  dismissExchange: async (exchangeId) => {
    return api.patch(`/exchanges/${exchangeId}/dismiss`)
  }
};
